import { Component, Input } from '@angular/core';
import { LowerCasePipe } from '@angular/common';
import { TranslatePipe } from '../../../core/services/translation/translate.pipe';

@Component({
    selector: 'app-vip-level-label',
    imports: [
        LowerCasePipe,
        TranslatePipe,
    ],
    templateUrl: './vip-level-label.component.html',
    styleUrl: './vip-level-label.component.scss'
})
export class VipLevelLabelComponent {

  @Input() levelName: string;
}
